/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import type {IconProps} from '@phosphor-icons/react';
import React from 'react';

export const NSFWLinkChannelIcon = React.forwardRef<SVGSVGElement, IconProps>(
	({size = 256, className, ...props}, ref) => (
		<svg
			ref={ref}
			width={size}
			height={size}
			viewBox="0 0 256 256"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			aria-hidden={true}
			{...props}
		>
			<path
				fill="currentColor"
				d="m245.254 92.0979-34.16-59.3242c-.854-1.4534-2.072-2.6585-3.535-3.4959C206.096 28.4405 204.44 28 202.754 28c-1.685 0-3.342.4405-4.805 1.2778-1.462.8374-2.681 2.0425-3.535 3.4959l-34.16 59.3242c-.821 1.4058-1.254 3.0047-1.254 4.6328 0 1.6282.433 3.227 1.254 4.6333.843 1.462 2.059 2.673 3.525 3.51s3.127 1.269 4.815 1.251h68.32c1.687.016 3.347-.416 4.811-1.253s2.679-2.047 3.521-3.508c.823-1.4056 1.257-3.0041 1.258-4.6322.002-1.6282-.43-3.2274-1.25-4.6339m-45.625-32.8476c0-.8288.329-1.6237.915-2.2098.587-.586 1.381-.9152 2.21-.9152s1.624.3292 2.21.9152c.586.5861.915 1.381.915 2.2098v15.625c0 .8288-.329 1.6236-.915 2.2097-.586.586-1.381.9153-2.21.9153s-1.623-.3293-2.21-.9153c-.586-.5861-.915-1.3809-.915-2.2097zm3.125 34.375c-.927 0-1.833-.275-2.604-.79-.771-.5151-1.372-1.2472-1.726-2.1037-.355-.8565-.448-1.799-.267-2.7083s.627-1.7445 1.283-2.4001c.655-.6556 1.49-1.102 2.4-1.2829.909-.1808 1.851-.088 2.708.2668s1.589.9556 2.104 1.7264c.515.7709.79 1.6772.79 2.6043 0 1.2432-.494 2.4354-1.373 3.3145s-2.072 1.373-3.315 1.373M105.37 76.0002c7.7.0001 15.324 1.517 22.437 4.4639 3.578 1.4823 6.991 3.3118 10.193 5.457v37.0739c-1.712-4.814-4.482-9.203-8.126-12.832-.006-.006-.014-.013-.02-.019-3.215-3.216-7.032-5.768-11.233-7.508S109.917 100 105.37 100s-9.0498.896-13.2506 2.636c-4.2009 1.74-8.0176 4.292-11.2325 7.508l-34.7422 34.742c-6.4876 6.487-10.1361 15.283-10.1445 24.457-.0083 9.174 3.6236 17.976 10.0986 24.475 3.2139 3.224 7.0326 5.783 11.2364 7.53s8.7113 2.649 13.2636 2.652c4.5525.004 9.0621-.891 13.2686-2.632 4.2064-1.74 8.0283-4.294 11.2471-7.513l5.1105-5.111c4.686-4.686 12.284-4.686 16.971 0 4.686 4.687 4.686 12.285 0 16.971l-5.11 5.109c-5.449 5.451-11.92 9.773-19.0418 12.72-7.1219 2.947-14.7554 4.462-22.4629 4.456-7.7076-.006-15.3387-1.532-22.4561-4.49s-13.582-7.29-19.0234-12.749l-.001-.001c-10.9641-11.002-17.1147-25.906-17.1006-41.438.0142-15.533 6.1916-30.426 17.1758-41.409l34.7393-34.7389c5.4432-5.4445 11.9059-9.7633 19.0185-12.71 7.1131-2.9469 14.7372-4.4638 22.4362-4.4639"
			/>
			<path
				fill="currentColor"
				d="M102.496 120.313c6.455-1.505 12.907 2.508 14.411 8.963 1.414 6.063 4.443 11.627 8.761 16.102l.422.43.009.01c3.214 3.224 7.032 5.783 11.236 7.53s8.711 2.649 13.264 2.652c4.552.004 9.062-.891 13.268-2.632 4.207-1.74 8.029-4.294 11.247-7.513L183.97 137h33.94l-25.824 25.824c-5.449 5.451-11.92 9.773-19.042 12.72s-14.755 4.462-22.463 4.456c-7.707-.006-15.338-1.532-22.456-4.49-7.117-2.958-13.582-7.29-19.023-12.749-7.701-7.712-13.0943-17.423-15.5686-28.037-1.5045-6.454 2.5086-12.907 8.9626-14.411"
			/>
		</svg>
	),
);
